
const state = {
  id: null,
  publication_id: undefined,
  pagination_rule_id: undefined,
}

export const requiredFields = [
  { key: 'publication_id' },
  { key: 'pagination_rule_id' },
]

export default state
